// export default "https://api.belajariqra1.com/api";
// export default 'https://192.168.1.32:3001/api';
// export default 'http://172.20.10.5:3001/api';
// export default "https://api.sistem-pembelajaran-audit.my.id/api"
export default 'http://localhost:3001/api';
